/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Inspired.PaymentPortal.API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from 'react-query';
import type { UseQueryOptions, QueryFunction, UseQueryResult, QueryKey } from 'react-query';
import type {
  InspiredPaymentPortalAPIAccessibleAccountsAccessibleAccountsResponse,
  InspiredLibrariesApiExceptionHandlingErrorResponse
} from '../../models/payments';
import { customInstance } from '../../utils/axiosInstance';
import type { ErrorType } from '../../utils/axiosInstance';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getAccessibleAccounts = () => {
  return customInstance<InspiredPaymentPortalAPIAccessibleAccountsAccessibleAccountsResponse>({
    url: `/api/accessible-accounts`,
    method: 'get'
  });
};

export const getGetAccessibleAccountsQueryKey = () => [`/api/accessible-accounts`] as const;

export const getGetAccessibleAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccessibleAccounts>>,
  TError = ErrorType<InspiredLibrariesApiExceptionHandlingErrorResponse>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAccessibleAccounts>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<typeof getAccessibleAccounts>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccessibleAccountsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessibleAccounts>>> = () =>
    getAccessibleAccounts();

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAccessibleAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccessibleAccounts>>
>;
export type GetAccessibleAccountsQueryError =
  ErrorType<InspiredLibrariesApiExceptionHandlingErrorResponse>;

export const useGetAccessibleAccounts = <
  TData = Awaited<ReturnType<typeof getAccessibleAccounts>>,
  TError = ErrorType<InspiredLibrariesApiExceptionHandlingErrorResponse>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getAccessibleAccounts>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAccessibleAccountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
